import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import IntlTelInput from 'react-intl-tel-input';
import { InputData } from './data/input-data';
import { InputError } from './data/input-error';
import { injectIntl } from 'react-intl';
import last from "lodash/last";
import lowerCase from "lodash/lowerCase";
import split from "lodash/split";

class PhoneNumberInputClass extends Component {
  constructor (props) {
    super(props);

    this.state = {
      countryCode: null,
      phoneNumber: null,
      country: null,
      errorMsg: null,
      error: null,
      phoneChanged: '',
      errorClass: ''
    };

    this.phoneChangeHandler = this.phoneChangeHandler.bind(this);
    this.flagChangeHandler = this.flagChangeHandler.bind(this);
    this.checkForIcon = this.checkForIcon.bind(this);
    this.getValue = this.getValue.bind(this);
    this.isValid = this.isValid.bind(this);
    this.setErrorState = this.setErrorState.bind(this);
    this.renderPhoneNumberDropdown = this.renderPhoneNumberDropdown.bind(this);
  }

  phoneChangeHandler (status, value, countryData, number, id) {
    let error;
    let errorClass;
    let errorMsg;
    if (value) {
      error = InputError.mobile_phone.error.validIcon;
      errorClass = '';
      errorMsg = '';
    }
    this.setState({
      countryCode: countryData.dialCode,
      phoneNumber: value,
      country: countryData.iso2,
      error: error,
      errorClass: errorClass,
      phoneChanged: !!value,
      errorMsg: errorMsg
    });
  }

  flagChangeHandler (countryData) {
    const node = ReactDOM.findDOMNode(this);
    const input = node.getElementsByTagName('input')[0];
    let value = input.value;
    this.setState({
      countryCode: countryData.dialCode,
      country: countryData.iso2,
      phoneNumber: value
    });
  }

  checkForIcon (error) {
    let icon = "";
    if (error && this.state.phoneChanged || this.state.errorMsg) {
      icon = <i className={"ico " + error}></i>
    } else if (!this.props.optional) {
      icon = <span className="required">*</span>
    }
    return <span className={"form-control-feedback"}>{icon}</span>
  }

  getValue () {
    const phoneVal = this.state.phoneNumber;
    return phoneVal;
  }

  isValid () {
    let errorFree = true;
    if (!this.props.optional && !this.state.phoneNumber) {
      this.setState({
        error: InputError.mobile_phone.error.errorIcon,
        errorClass: 'error',
        errorMsg: "Please enter your mobile phone."
      })
      errorFree = false;
    } else if (this.state.phoneChanged) {
      const user = {};
      user.phone_country_code = this.state.countryCode;
      user.phone = this.state.phoneNumber;
      user.phone_country = this.state.country;
      this.props.actionFn(user, function fireOnCallback(...args) {
        this.props.actionCb(
          this.setErrorState,
          ...args);
        // set state to isValid to true or false depending on
        // response of callback
        // if error will output error msg and display error state UI
      }.bind(this));
    }
    return errorFree;
  }

  setErrorState (errorMsg) {
    this.setState({
      errorMsg: errorMsg
    });
  }

  renderPhoneNumberDropdown () {
    const { error, errorClass } = this.state;
    const locale = this.props.intl.locale;
    const country = this.props.defaultCountry || last(split(locale, '-'));

    return (
      <div className={this.props.inputColSize}>
        <div className="form-group has-feedback">
          <div className="col-xs-12">
            <IntlTelInput
              containerClassName="intl-tel-input"
              inputClassName={`form-control rr-block ${errorClass}`}
              defaultCountry={ lowerCase(country) }
              preferredCountries={['us', 'gb', 'de', 'fr', 'es']}
              onSelectFlag={this.flagChangeHandler}
              onPhoneNumberChange={this.phoneChangeHandler}
              ref="phone_input"
              fieldId={InputData.mobile_phone.values.id}
              value={this.state.phoneNumber || this.props.defaultVal || ''}
              defaultValue={this.props.defaultVal}
            />
            {this.checkForIcon(error)}
            <div className="help-block text-left info-text">
              {this.props.helperText}
            </div>
            <div className="text-left text-danger" style={{ fontSize: 14 }}>{this.state.errorMsg}</div>
          </div>
        </div>
      </div>
    );
  }

  render () {
    return this.renderPhoneNumberDropdown();
  }
}

PhoneNumberInputClass.defaultProps = {
  inputColSize: 'col-xs-12',
  helperText: InputData.mobile_phone.values.helper_text
};

PhoneNumberInputClass.propTypes = {
  optional: PropTypes.bool, // determines whether input is optional
  actionFn: PropTypes.func,
  actionCb: PropTypes.func,
  intl: PropTypes.object
};

export const PhoneNumberInput = injectIntl(PhoneNumberInputClass, { withRef: true, forwardRef: true });
